import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { useLang, PHONE_TEL, PHONE_DISPLAY, waLink } from "@/i18n";

export const Footer = () => {
    const { t } = useLang();
    const routes = t("footer.routes");
    return (
        <footer
            data-testid="main-footer"
            className="border-t border-[#D4AF37]/20 bg-[#060608] pt-16 pb-8 px-5 lg:px-8"
        >
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                <div>
                    <div className="flex items-center gap-3 mb-5">
                        <Logo size={52} />
                        <div className="leading-tight">
                            <span className="ff-accent block text-[#E6C687] tracking-[0.2em]">
                                GİRNE 1
                            </span>
                            <span className="ff-sans block text-[10px] tracking-[0.45em] text-zinc-500">
                                VIP TAKSİ
                            </span>
                        </div>
                    </div>
                    <p className="text-sm text-zinc-400 ff-sans font-light leading-relaxed">
                        {t("footer.desc")}
                    </p>
                </div>

                <div>
                    <h4 className="ff-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
                        {t("footer.quickTitle")}
                    </h4>
                    <ul className="space-y-3 text-sm ff-sans">
                        <li><Link to="/" className="text-zinc-400 hover:text-[#E6C687] transition-colors" data-testid="footer-link-home">{t("nav.home")}</Link></li>
                        <li><Link to="/ercan-transfer" className="text-zinc-400 hover:text-[#E6C687] transition-colors" data-testid="footer-link-ercan">{t("nav.ercan")}</Link></li>
                        <li><Link to="/girne-taksi" className="text-zinc-400 hover:text-[#E6C687] transition-colors" data-testid="footer-link-girne">{t("nav.girne")}</Link></li>
                        <li><Link to="/#filo" className="text-zinc-400 hover:text-[#E6C687] transition-colors" data-testid="footer-link-fleet">{t("nav.fleet")}</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="ff-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
                        {t("footer.routesTitle")}
                    </h4>
                    <ul className="space-y-3 text-sm ff-sans">
                        {Array.isArray(routes) &&
                            routes.map((r, i) => (
                                <li key={r}>
                                    <a
                                        href={waLink(t("routes.waMsg")(r))}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-zinc-400 hover:text-[#E6C687] transition-colors"
                                        data-testid={`footer-route-${i}`}
                                    >
                                        {r}
                                    </a>
                                </li>
                            ))}
                    </ul>
                </div>

                <div>
                    <h4 className="ff-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
                        {t("footer.contactTitle")}
                    </h4>
                    <div className="space-y-4 text-sm ff-sans">
                        <a href={PHONE_TEL} className="flex items-center gap-3 text-zinc-300 hover:text-[#E6C687] transition-colors" data-testid="footer-phone-link">
                            <Phone size={15} className="text-[#D4AF37]" /> {PHONE_DISPLAY}
                        </a>
                        <a href={waLink(t("hero.waMsg"))} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-zinc-300 hover:text-[#E6C687] transition-colors" data-testid="footer-whatsapp-link">
                            <MessageCircle size={15} className="text-[#D4AF37]" /> WhatsApp
                        </a>
                        <div className="flex items-center gap-3 text-zinc-400">
                            <MapPin size={15} className="text-[#D4AF37]" /> Girne / KKTC
                        </div>
                        <div className="flex items-center gap-3 text-zinc-400">
                            <Clock size={15} className="text-[#D4AF37]" /> {t("contact.hours")}
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto mt-14 pt-7 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
                <p className="text-xs text-zinc-500 ff-sans" data-testid="footer-copyright">
                    © {new Date().getFullYear()} Girne 1 Taksi — girne1taksi.com. {t("footer.rights")}
                </p>
                <div
                    className="gold-glow-hover flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-5 py-2"
                    data-testid="footer-ektiren-credit"
                >
                    <span className="ff-sans text-[10px] tracking-[0.25em] uppercase text-zinc-400">
                        {t("footer.madeBy")}
                    </span>
                    <span className="ff-accent text-xs tracking-[0.15em] text-gold-gradient">
                        Ektiren Project
                    </span>
                </div>
            </div>
        </footer>
    );
};
